export const columns = function() {
  return [
    {
      prop: 'value',
      label: '支付渠道',
      minWidth: 50
    },
    {
        prop: 'status',
        label: '状态',
        minWidth: 100,
        render: ({ status }) => {
            return status ? '已禁用' : '已启用'
        }
    },
	{
	  prop: "handle",
	  label: "操作",
	  minWidth: 50,
	},
  ]
} 


export default {}